import { requestReducerForTypes } from '../requestReducer';
import { ApiState } from '../../utils/requestAction';
import User, { ADMIN, CLIENT, VENDOR, STAFF, HEADSALES, Role, MANAGER } from '../../models/User';

export const hasRole = ({ roles }: SessionState, role: Role): boolean => !!roles && roles.includes(role)
export const isAdmin = (session: SessionState): boolean => hasRole(session, ADMIN)
export const isClient = (session: SessionState): boolean => hasRole(session, CLIENT)
export const isStaff = (session: SessionState): boolean => hasRole(session, STAFF)
export const isHeadSales = (session: SessionState): boolean => hasRole(session, HEADSALES)
export const isManager = (session: SessionState): boolean => hasRole(session, MANAGER)
export const isVendor = (session: SessionState): boolean => hasRole(session, VENDOR)
export const isInternal = (session: SessionState): boolean => hasRole(session, STAFF) || hasRole(session, HEADSALES) || hasRole(session, MANAGER) || hasRole(session, VENDOR) || hasRole(session, ADMIN)
export const isLogged = ({ email }: SessionState): boolean => !!email
export const isLoggedIn = ({ email }: SessionState, user?: User) => user && user.email === email

export interface SessionState extends ApiState {
  fullName: string | null
  clientName: string | null
  byPersonTypeId: number | null
  personType: string | null
  personId: number | null
  orionId: number | null
  email: string | null
  roles: Role[] | null
  shouldUpdatePassword: boolean
  countryId: number | null
  currentPriceListId: number | null
  categoryId: number | null
  allowAddDeliveryLocation: boolean | null
  tokenExpired: boolean | null
  isChaco: boolean | null
}

const empty = {
  fullName: null,
  clientName: null,
  byPersonId: null,
  personId: null,
  email: null,
  roles: null,
  countryId: null,
  currentPriceListId: null,
  allowAddDeliveryLocation: null,
  tokenExpired: false
}

export default requestReducerForTypes<SessionState>(['SESSION', 'SESSION_CLOSED', 'TOKEN_EXPIRED'],
 (state, action) => {
    if (action.type === 'TOKEN_EXPIRED') {
      return { ...state, tokenExpired: true }
    }

    if (action.requestStatus === 'FETCH') {
      return state
    }

    return { ...state, ...empty }
  }
)
